module.exports = __webpack_public_path__ + "static/mutu-b19907fb2c4a0ae898e88f0f74e9443b.png";